export default __webpack_public_path__ + "static/media/elearning.f277d2a3.svg";